import { Dispatch, SetStateAction } from 'react';

import { UseFormWatch } from 'react-hook-form';

import { LinksView } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/LinksView/LinksView';
import { AddAssociatedDocuments } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/addAssociatedDocuments';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/desktop/AssociatedDocuments.desktop.module.scss';

interface Props {
    watch: UseFormWatch<any>;
    setShowAddAssociatedDocuments: Dispatch<SetStateAction<boolean>>;
    handleAddAssociatedDocumentsLinks: (data) => void;
    handleAddAssociatedDocumentsFiles: (data) => void;
    showAddAssociatedDocuments: boolean;
    handleDeleteAssociatedDocumentsLinks: (index: number) => void;
    handleDeleteAssociatedDocuments: (id: number) => void;
}

export const AssociatedDocumentsDesktop = ({
    watch,
    setShowAddAssociatedDocuments,
    handleAddAssociatedDocumentsLinks,
    handleAddAssociatedDocumentsFiles,
    showAddAssociatedDocuments,
    handleDeleteAssociatedDocumentsLinks,
    handleDeleteAssociatedDocuments,
}: Props) => {
    const numberOfExternalDocuments =
        (watch('externalDocuments') && watch('externalDocuments').filter((doc) => doc.delete === undefined).length) ||
        0;
    const numberOfExternalLinks = (watch('externalLinks') && watch('externalLinks').length) || 0;
    const numberOfAttachments: number = numberOfExternalDocuments + numberOfExternalLinks;

    return (
        <div className={classes.associatedDocumentsContainer}>
            <div
                className={classes.addDocumentBtn}
                onClick={() => setShowAddAssociatedDocuments(true)}
                id={'cardModalExternalLinksButton'}
            >
                <span>{`Associated Documents (${numberOfAttachments}): `}</span>
                <div className={classes.associatedDocumentsPlus}>+</div>
            </div>
            <AddAssociatedDocuments
                hasExternalDocumentsProperty={watch('externalDocuments') !== undefined}
                handleClose={() => setShowAddAssociatedDocuments(false)}
                handleAddDocumentsLink={handleAddAssociatedDocumentsLinks}
                showAddAssociatedDocuments={showAddAssociatedDocuments}
                handleAddAssociatedDocumentsFiles={handleAddAssociatedDocumentsFiles}
            />
            <LinksView
                watch={watch}
                handleDeleteAssociatedDocumentsLinks={handleDeleteAssociatedDocumentsLinks}
                handleDeleteAssociatedDocuments={handleDeleteAssociatedDocuments}
            />
        </div>
    );
};
